import React, { useEffect } from 'react'

/**
 *
 * @param {object} props
 * @param {string} props.customCSS
 * @param {function} props.setCustomCSS
 */
export default function CSSCustomStyle({ customCSS, setCustomCSS }) {
  useEffect(() => {
    const handleTabKeyPress = (event) => {
      if (event.key === 'Tab') {
        if (event.preventDefault) {
          event.preventDefault()
        }
        setCustomCSS((customCSS || '').concat('    '))
      }
    }
    document.addEventListener('keydown', handleTabKeyPress)
    return () => document.removeEventListener('keydown', handleTabKeyPress)
  }, [customCSS, setCustomCSS])

  return (
    <textarea
      cols={5}
      rows={8}
      value={customCSS || ''}
      onChange={(e) => setCustomCSS(e.target.value)}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CSSCustomStyle/index.js